import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { searchAddresses } from "./search-addresses";
import type { AddressSuggestion } from "@shared-kernel/application/ports/public/public-repository";

const initialState: RetrievalState<AddressSuggestion[]> = { fetching: "idle", data: [] };

export const searchAddressesReducer = createReducer<RetrievalState<AddressSuggestion[]>>(initialState, builder => {
  builder.addCase(searchAddresses.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(searchAddresses.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(searchAddresses.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
